import circularJSON from 'circular-json';
import serialize from 'serialize-javascript';

const storage = {

  status: true,

  check: (value) => {
    let status = true;
    try {
      serialize(value, { isJson: true });
    } catch (err) {
      status = false;
    }

    storage.status = status;
  },

  set: (key, value) => {
    let str = null;
    try {
      storage.check(value);
      if (storage.status) {
        str = serialize(value, { isJson: true });
      } else {
        str = circularJSON.stringify(value);
      }
      sessionStorage.setItem(key, str);
    } catch (err) {
      return false;
    }
  },

  get: (key) => {
    let str = null;
    // prevent JSON.parse error on undefined keys
    const originalValue = sessionStorage.getItem(key) || 'null';

    if (storage.status) {
      str = JSON.parse(originalValue);
    } else {
      str = circularJSON.parse(originalValue);
    }

    return str;
  },

  remove: (key) => {
    sessionStorage.removeItem(key);
  },

};
export default storage;
